



import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { myport } from "../../App";


export const calltodayatndnc_service = createAsyncThunk("calltodayatndnc", async (data) => {
    console.log(data[1])
    
    const response = await fetch(`${myport}attendance_get/${data[1]}/?page=1`,{headers: {
        'Authorization': `Bearer ${data[0]}`,
      },credentials:"include",});
      const jsondata = await response.json();
      console.log(jsondata)
      
      return [jsondata,response.status];
})

export const todayatndncSlice = createSlice({
    name: "todayatndnc",
    initialState: {
        data: null,
        loading: false,
        status: "",
        error: null,

      },
      reducers: {
        handlesetstatuserrortoday(state,action) {
            state.data = null;
            console.log(state.status)
            console.log(state.error)
            if (state.status === "401") {
                state.status = ""
            }
            if (state.error === "alreadyloggedout") {
                state.error = null;
            }
          },
      },
      extraReducers: (builder) => {
        builder.addCase(calltodayatndnc_service.pending, (state)=> {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(calltodayatndnc_service.fulfilled, (state,action) => {
            if (action.payload[0] === "alreadyloggedout") {
                state.error = "alreadyloggedout"

            } else if (action.payload[1] === 200) {
            state.data = action.payload[0];
            state.error = null;

           } else {
            state.error = null;
            console.log(action.payload[1])

           }
            
            
            state.status = `${action.payload[1]}`;
            state.loading = false;
            console.log(state.status);
        });
        builder.addCase(calltodayatndnc_service.rejected, (state,action) => {
            state.loading = false;
            state.error = action.error.message;
        });
      },
    
});

export const { handlesetstatuserrortoday } = todayatndncSlice.actions
export default todayatndncSlice.reducer